"use client";

import { datadogRum } from "@datadog/browser-rum";
import assert from "assert";
import { useEffect } from "react";

export function RealTimeUserMonitoring() {
  const clientToken             = process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN;
  const applicationId           = process.env.NEXT_PUBLIC_DD_APPLICATION_ID;
  const env                     = process.env.NEXT_PUBLIC_BOOM_ENV;
  const sessionSampleRate       = Number(process.env.NEXT_PUBLIC_DD_SESSION_SAMPLE_RATE);
  const sessionReplaySampleRate = Number(process.env.NEXT_PUBLIC_DD_SESSION_REPLAY_SAMPLE_RATE);
  const defaultPrivacyLevel     = process.env.NEXT_PUBLIC_DD_DEFAULT_PRIVACY_LEVEL as "allow" | "mask" | "mask-user-input";
  const applicationVersion      = process.env.NEXT_PUBLIC_BUILD_VERSION;

  const includeRealTimeUserMonitoring = clientToken
                                     || applicationId
                                     || sessionSampleRate
                                     || sessionReplaySampleRate
                                     || defaultPrivacyLevel;

  useEffect(() => {
    if (includeRealTimeUserMonitoring && !datadogRum.getInitConfiguration()) {
      assert(clientToken,   "NEXT_PUBLIC_DD_CLIENT_TOKEN is required to include Real Time User Monitoring");
      assert(applicationId, "NEXT_PUBLIC_DD_APPLICATION_ID is required to include Real Time User Monitoring");
      assert(env,           "NEXT_PUBLIC_BOOM_ENV is required to include Real Time User Monitoring");
      assert(Number.isFinite(sessionSampleRate),       "NEXT_PUBLIC_DD_SESSION_SAMPLE_RATE must be a number as is required to include Real Time User Monitoring");
      assert(Number.isFinite(sessionReplaySampleRate), "NEXT_PUBLIC_DD_SESSION_REPLAY_SAMPLE_RATE must be a number and is required to include Real Time User Monitoring");
      assert(defaultPrivacyLevel && ["allow", "mask", "mask-user-input"].includes(defaultPrivacyLevel), "NEXT_PUBLIC_DD_DEFAULT_PRIVACY_LEVEL must be one of 'allow', 'mask', or 'mask-user-input' and is required to include Real Time User Monitoring");
      assert(applicationVersion, "NEXT_PUBLIC_BUILD_VERSION is required to include Real Time User Monitoring");

      datadogRum.init({
        clientToken: clientToken,
        applicationId: applicationId,
        site: 'datadoghq.com',
        service: 'boomerang',
        env: env,
        sessionSampleRate,
        sessionReplaySampleRate,
        defaultPrivacyLevel,
        trackBfcacheViews: true,
        version: applicationVersion
      });
    }
  }, [includeRealTimeUserMonitoring, clientToken, applicationId, env, sessionSampleRate, sessionReplaySampleRate, defaultPrivacyLevel, applicationVersion]);

  return null;
}
